export const EMAIL_TABLE_ROW_ACTIVITIES_VISIBLE_COUNT = 1

export const EMAIL_TABLE_ROW_ACTIVITIES_DROPDOWN_STYLES = {
  maxHeight: 260,
  maxWidth: 320,
  minWidth: 320,
}
